<template>
    <b-card class="home-number-panel">
        <b-card-body v-if="!busy" body-class="text-center">
            <div v-if="counter > 0">
                <div class="card-title">{{ title }}</div>
                <div class="card-counter">{{ counter }}</div>
            </div>
            <span v-else>
                <app-no-data-image class="d-sm-none d-md-block" width="100%" :imgSrc="'no-'+ panelType + '.png'" imageClass="w-75" />
                <span class="d-sm-block d-md-none">
                    <div class="card-title">{{ title }}</div>
                    <div class="card-counter">{{ counter }}</div>
                </span>
            </span>
            
        </b-card-body>
        <b-card-body v-else body-class="text-center p-3">
            <b-skeleton width="85%" class="mb-3"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    props: {
        title : {
            type: String,
            default: '-',
        },
        counter : {
            type: [String, Number],
            default: 0,
        },
        busy : {
            type: Boolean,
            default: false
        },
        panelType : {
            type: String,
            default: "inbox"
        }
    }
}
</script>